import parseDate from "src/utils/parse-date";

const ParseDate = ({ children }) => {
  return parseDate(children);
};

export default ParseDate;
